import React, { Component } from 'react';
import './all-questions.scss';
import { Constants, ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import CwContentViewer from '../../../common/cw-content-viewer/cw-content-viewer'
import CanvasPreview from '../../../common/canvas/canvas'
import TestApi from '../../../../apis/test'
import GeometryTranspiler from '../../../common/geometry/geometry-parser'

class AllQuestions extends Component {

    state = {
        completedStudents: [],
        notCompletedStudents: [],
        questions: [],
        usersInfo: []
    }


    selectedItem = {

    }

    constructor(props) {
        super(props)

        console.log(this.props.payload)

    }


    componentDidMount() {

        if (this.props.type === 'JIGYAGA_ASSESSMENT') {
            this.setState({questions : this.props.selectedItem.questionsList})
        } else {
            this.getAllQuestionList()
        }


        document.addEventListener('mousedown', this.handleClickEvent, false);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickEvent, false);
    }

    handleClickEvent = (event) => {
        if (this.studentRef && !this.studentRef.contains(event.target)) {
            this.setState({ showStudentIndex: -1 })
        }
    }

    

    getAllQuestionList(payload = {}) {
        console.log(this.props.selectedItem)

        payload.assessmentId = this.props.selectedItem?._id
        TestApi.getAllQuestionList(payload)
            .then(response => {
                // console.log(response.response)
                this.setState({ questions: response.questions || [], basePath: response.basePath })
            }).catch(err => {
            })
    }

    // getChapterNames(chapters) {
    //     let arr = []
    //     for (let i = 0; i < chapters.length; i++) {
    //         arr.push(chapters[i])
    //     }
    //     return arr.join(", ")
    // }

    // renderBreadcrumb = () => {
    //     return (
    //         <div className='breadcrumb ml-4'>
    //             <span>{this.selectedItem?.class || ""}</span>
    //             <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
    //             <span className='pl-2'>{this.getChapterNames(this.selectedItem?.chapters)} {`>`} </span>
    //             <span className='active pl-2'>{this.getDate(this.selectedItem?.createdDate)}</span>
    //         </div>
    //     )
    // }

    // getDate = (timeStamp, getYear) => {

    //     let dateFormat = new Date(timeStamp).toDateString();

    //     let date = dateFormat.split(" ")[2];

    //     let month = dateFormat.split(" ")[1];

    //     let year = dateFormat.split(" ")[3];

    //     if (getYear) {
    //         return date + " " + month + " " + year;
    //     } else {
    //         return date + " " + month;
    //     }
    // }

    // onClickBack = () => {
    //     this.props.delegate && this.props.delegate.hideCompletionReport && this.props.delegate.hideCompletionReport()
    // }

    onClickBack = () => {
        this.props.close()
    }

    renderResultColor = (result) => {

        switch (result) {
            case 'Correct':
                return '#4CCAB7'

            case 'Incorrect':
                return '#FF7171'

            case 'Not Attempted':
                return '#FFC571'

            default:
                return '#FFC571'
        }

    }

    renderContentType = (contentType, content) => {

        switch (contentType) {

            case 1:
                return (
                    <div>
                        <div className='row'>
                            {content.content.options.map((item, index) =>

                                <div className='col col-lg-6 col-md-6 col-sm-12'>
                                    <div className={`mb-4 ml-2 row sequence-option ${item.isCorrect ? 'correct-answer-light-border' : ''} `} >
                                        <div className='col-1 my-auto col-min-width'>
                                            {item.isCorrect && <img className='answer-result-icon' src={getImageSource(ImageConstants.CORRECT_ANSWER)} onClick={() => this.onClickBack()} />}
                                        </div>
                                        <div className='col my-auto'>{item.contentTypeName == 'TEXT' ?
                                            <CwContentViewer content={item.content} />
                                            :
                                            <div className=''>
                                                <img className='image-option-container' src={item.content} alt="" />
                                            </div>
                                        }
                                        </div>

                                    </div>
                                </div>

                            )}

                        </div>
                    </div >

                )

            case 2:
                return (
                    <div className="row">
                        {content.content.options.map((item, index) =>
                            <div className="col col-lg-6 col-md-6 col-sm-11">

                                <div className='mb-4 ml-2 row sequence-option'>
                                    <div className='col-1 my-auto'>
                                        <div className='check-box'></div>
                                    </div>
                                    <div className='col my-auto'>{item.contentTypeName == 'TEXT' ?
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>
                                </div>

                            </div>
                        )}

                    </div>

                )

            case 4:
                return (

                    <div className='mb-4'>
                        <div className='row'>
                            {content.content.options.map((item, index) =>
                                <div className={`col-2 matching-option my-auto `} style={{ borderColor: 'red' }}>
                                    {item.question.contentTypeName == 'TEXT' ?
                                        <div className='match-option'><CwContentViewer content={item.question.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.question.content} alt="" />
                                        </div>
                                    }
                                    <div className='text-center'><img className='match-arrow my-2' onClick={this.props.onClose} src={getImageSource(ImageConstants.MATCHING_ARROW)} /></div>
                                    {item.answer.contentTypeName == 'TEXT' ?
                                        <div className='match-option'><CwContentViewer content={item.answer.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.answer.content} alt="" />
                                        </div>
                                    }
                                </div>
                            )}

                        </div>
                    </div>

                )

            case 5:

                return (
                    <div className='mb-4'>
                        <div >
                            {content.content.options.map((item, index) =>
                                <div className='mb-4 ml-2 row sequence-option'>
                                    <div className='col-2 my-auto'>
                                        <img className='match-arrow drag-container' onClick={this.props.onClose} src={getImageSource(ImageConstants.DRAG_ICON)} />
                                    </div>
                                    <div className='sequence-border'></div>
                                    <div className='col my-auto'>{item.contentTypeName == 'TEXT' ?
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 6:

                let items = []

                for (let i = 0; i < content.content.options.length; i++) {
                    items = items.concat(content.content.options[i].items)
                }
                return (
                    <div className='mb-4'>
                        <div className='row option-wrapper '>
                            {items.map((item, index) =>
                                <div className='ml-2 mt-4'> {item.contentTypeName == 'TEXT' ?
                                    <div className='group-items'><CwContentViewer content={item.content} /></div>
                                    :
                                    <div className='group-items'>
                                        <img className='image-option-container' src={item.content} alt="" />
                                    </div>
                                }</div>
                            )}
                        </div>
                        <div className='row mt-4'>
                            {content.content.options.map((item, index) =>
                                <div className='ml-2 group-option'>
                                    <div className='group-header px-3'>
                                        <div className='text-center mt-2'><CwContentViewer content={item.title} /></div>
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>
                )

            case 10:
                if (content?.content?.canvas?.render?.script) {
                    let payload = GeometryTranspiler.transpile(content.content.canvas.render.script, 37.7952755906, 5) //centimeter ratio and x offset
                    if (payload) {
                        let { maxWidth, maxHeight } = this.getCanvasSize(payload)
                        this.canvasMaxWidth = maxWidth + 100
                        this.canvasMaxHeight = maxHeight + 100
                    }

                    return (
                        <CanvasPreview id={Math.random()} coordinates={payload} maxWidth={this.canvasMaxWidth} maxHeight={this.canvasMaxHeight} />
                    )
                }

            default:
                return ("")
        }

    }
    getCanvasSize(coordinates = []) {
        if (!coordinates) return {}
        let maxHeight = 0, maxWidth = 0
        for (let i = 0; i < coordinates.length; i++) {
            for (let j = 0; j < coordinates[i].points.length; j++) {
                if (maxWidth < coordinates[i].points[j].x) {
                    maxWidth = coordinates[i].points[j].x
                }
                if (maxHeight < coordinates[i].points[j].y) {
                    maxHeight = coordinates[i].points[j].y
                }
            }
        }
        return { maxHeight, maxWidth }
    }

    showSubmissions = (item, index) => {
        this.setState({ showSubmissions: true, selectedQuestion: item, selectedIndex: index })
    }

    toggleBack = () => {

        if (this.state.showSubmissions) {
            this.setState({ showSubmissions: false })
        } else {
            this.props.close()
        }

    }

    getStatusText(value) {
        if (value == "CORRECT") return "Correct"
        else if (value == "IN_CORRECT") return "Incorrect"
        return "Not Attempted"
    }

    getStatusColor(value) {
        if (value == "CORRECT") return "text-success"
        else if (value == "IN_CORRECT") return "text-danger"
        return "text-warning"
    }

    onClickStatus(item, index, status) {

        let stats = item.stats

        let students = []

        if (status == "CORRECT") {
            students = stats?.correctUsers || []
        } else if (status == "IN_CORRECT") {
            students = stats?.inCorrectUsers || []
        } else if (status == "NOT_ATTEMPTED") {
            students = stats?.notAttemptedUsers || []
        }

        this.setState({ selectedQuestion: item, students, showStudentIndex: index, status })

    }

    closeStudents() {
        this.setState({ selectedItem: null, showStudentIndex: -1, reload: true }, () => {
            this.setState({ reload: false })
        })
    }

    renderStudentCard() {
        return (
            <div className='students-card' ref={ref => this.studentRef = ref}>

                <div className="row">
                    <div className="col">
                        <img className="close-icon cursor-pointer" onClick={(event) => this.closeStudents()} src={getImageSource(ImageConstants.CROSS)} />
                    </div>
                </div>

                {
                    this.state.students?.length ? this.state.students.map((item, index) =>
                        <div className='px-4 py-2 row align-items-center'>
                            <div className="profile-avatar text-center mr-2 d-inline-block">
                                <div className="row justify-content-center">
                                    {item.image ? <img className="" alt="img" src={`${this.state.basePath}${item.image}`} />
                                        :
                                        <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                </div>
                            </div>
                            <div className='student-name ml-2'>
                                {item.name}
                            </div>
                        </div>

                    )
                        :
                        <div className="text-center pt-4">No Records Found</div>
                }
            </div>
        )
    }

    render() {


        return (
            <div className='completion-report'>

                {this.props?.title || this.state.showSubmissions ? <div className='ml-4' >
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.toggleBack()} />
                </div> : ''}
                <div className="abs-image">
                    <img className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                </div>

                <div className="pt-4 my-auto text-right"><img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={() => this.onClickBack()} /></div>
                <div className=' mt-4 qs-font-weight'>All Questions</div>
                <div className='mt-3 apx-time-size'>
                    <span className=""><span><span>Total Qs. Selected : </span> <b className="pl-1"> {this.props.selectedItem?.questions || 0}</b></span></span>
                    <span className="p-2 ml-5"><span><span>Estimated Time : </span> <b className="pl-1">{this.props.selectedItem?.time || 0} </b>mins</span></span>

                </div>

                <div className='container-1 mt-0'>


                    {/* <div className='item-2'>
                        <div className="col screen-title p-0">{this.props?.title || this.state.showSubmissions ? "Submission at Question Level" : "All Questions"}</div>
                    </div> */}
                </div>
                {/* <div className=''>{this.renderBreadcrumb()}</div> */}


                {/* <div className=" pt-4 mb-5" >
                    <div className="col screen-title p-0">{this.props?.title || this.state.showSubmissions ? "Submission at Question Level" : "All Questions"}</div>
                    <div className=''>{this.renderBreadcrumb()}</div>
                </div> */}

                {!this.state.showSubmissions ? <div className='answer-sheet'>
                    <div className='cw-plain-card cw-answer-sheet-card-wrapper mt-4 mb-4 ml-4 mr-2'>
                        {this.state.questions && this.state.questions.length ?
                            this.state.questions.map((item, index) =>
                                <div className="">
                                    <div className='row mx-1 mb-3 question-container'>
                                        <div className='sub-title'>Question {index + 1}</div>
                                        {/* <div className='row mr-4'>
                                            <div className='mr-4 change-color cursor-pointer' onClick={() => this.showSubmissions(item, index)}>{'View Submissions >>'}</div>
                                        </div> */}
                                    </div>
                                    {/* <div className='row'> */}
                                    <div className=''>
                                        <CwContentViewer content={item.content.title} />
                                        <div className='mt-3'>{this.renderContentType(item.content.type, item)}</div>
                                        {/* <div className='row'>
                                            <div className='row ml-3 status-row'>
                                                <div className='dot green-dot'></div>
                                                <span className='roll-no cursor-pointer' onClick={() => this.onClickStatus(item, index, "CORRECT")}>Correct: <strong>{item?.stats?.correct || 0}</strong></span>
                                                {
                                                    this.state.showStudentIndex === index && this.state.status == "CORRECT" ? this.renderStudentCard() : ""
                                                }
                                            </div>
                                            <div className='row ml-5 status-row'>
                                                <div className='dot red-dot'></div>
                                                <div className='roll-no cursor-pointer' onClick={() => this.onClickStatus(item, index, "IN_CORRECT")}> InCorrect: <strong>{item?.stats?.inCorrect || 0}</strong></div>
                                                {
                                                    this.state.showStudentIndex === index && this.state.status == "IN_CORRECT" ? this.renderStudentCard() : ""
                                                }
                                            </div>
                                            <div className='row ml-5 status-row' >
                                                <div className='dot yellow-dot'></div>
                                                <div className='roll-no cursor-pointer' onClick={() => this.onClickStatus(item, index, "NOT_ATTEMPTED")} > Not Attempted: <strong>{item?.stats?.notAttempted || 0}</strong></div>
                                                {
                                                    this.state.showStudentIndex === index && this.state.status == "NOT_ATTEMPTED" ? this.renderStudentCard() : ""
                                                }
                                            </div>

                                        </div> */}
                                    </div>
                                    {index != this.state.questions.length - 1 && <div className='text-center'><img className="separator" src={getImageSource(ImageConstants.SEPARATOR)} /></div>}

                                </div>
                            ) : <div className="text-center">No Record's Found</div>}
                    </div>

                </div > : ""
                }

                {/* {
                    this.state.showSubmissions ?
                        <div className="">

                            <div className='row cw-plain-card cw-answer-sheet-card-wrapper mx-1 ml-4 mr-2'>

                                <div className='col-12'>
                                    <div className='row mx-1 mb-3 question-container'>
                                        <div className='sub-title'>Question {this.state.selectedIndex + 1}</div>

                                    </div>
                                    <CwContentViewer content={this.state.selectedQuestion.content.title} />
                                    <div className='mt-3'>{this.renderContentType(this.state.selectedQuestion.content.type, this.state.selectedQuestion)}</div>
                                    <div className='row'>
                                        <div className='row ml-3'>
                                            <div className='dot green-dot'></div>
                                            <span className='roll-no'>Correct:<strong>{this.state.selectedQuestion?.stats?.correct || 0}</strong></span>
                                        </div>
                                        <div className='row ml-5'>
                                            <div className='dot red-dot'></div>
                                            <div className='roll-no'>In-Correct:<strong>{this.state.selectedQuestion?.stats?.inCorrect || 0}</strong></div>
                                        </div>
                                        <div className='row ml-5' >
                                            <div className='dot yellow-dot'></div>
                                            <div className='roll-no'>Not Attempted:<strong>{this.state.selectedQuestion?.stats?.notAttempted || 0}</strong></div>
                                        </div>

                                    </div>
                                    <div className='text-center align-items-center'><img className="separator" src={getImageSource(ImageConstants.SEPARATOR)} /></div>
                                </div>


                                <div id="table-scoll" className="table-responsive mt-8">
                                    <table className="table cw-table mb-0 align-items-center custom-test-table">
                                        <tbody className="bg-white">
                                            {
                                                this.state.selectedQuestion?.stats?.users?.length ? this.state.selectedQuestion?.stats?.users?.map((item, index) => (
                                                    <>
                                                        <tr key={item._id} className="mt-4 border-bottom-tr">
                                                            <td className="img-td">{
                                                                item.image ?
                                                                    <img className='student-image' src={`${this.state.basePath}${item.image}`} />
                                                                    :
                                                                    <img className='student-image' src={Constants.ALTERNATE_STUDENT_IMAGE} />
                                                            }</td>

                                                            <td>{item.name}</td>
                                                            <td>Marks: {item.mark} </td>
                                                            <td className=""><span className={this.getStatusColor(item.status)}><b>{this.getStatusText(item.status)}</b></span></td>
                                                        </tr>
                                                        {
                                                            this.state.selectedQuestion?.stats?.users?.length - 1 != index ?
                                                                <tr className="p-0 m-0">
                                                                    <td className="p-0 m-0" colSpan="5" align='center'><img className="separator-1" src={getImageSource(ImageConstants.SEPARATOR)} /></td>
                                                                </tr>
                                                                : ""
                                                        }
                                                    </>
                                                ))
                                                    : <tr className="bg-white pt-4"><td colSpan="5" align='center'>No Records found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div >

                            </div>



                        </div> : ""
                } */}
            </div >
        );
    }
}

export default AllQuestions;